import React, { useEffect, useState } from "react";
import { getBasketNote, getBasketProductNote, updateBasketNote, updateBasketProductNote } from "services/allServices";
// import Image from 'next/image';
import SimpleTextArea from "components/FormElements/SimpleTextArea";
import Button from "components/FormElements/Button";
import { useConfigurationStore } from "store/ConfigurationStore";
import { successToast } from "../Toast/AllToast";

export default function AddNoteModal({ setOpenModal, onClick, basket, product }) {
  const [configurationNote, setConfigurationNote] = useConfigurationStore((state) => [state.configurationNote, state.setConfigurationNote]);
  const [text, setText] = useState("");
  const onSetNote = async () => {
    if (basket) {
      let configure = {
        note: text
      };
      await updateBasketNote(configure).then(res => {
        successToast("Başarılı","Notunuz başarıyla güncellendi.");
      })
      setOpenModal(false);
    } else {
      if (product) {
        let configure = {
          basket_id: product.basket_id,
          basket_product_id: product.id,
          product_id: product.product_id,
          product_note: text

        };
        await updateBasketProductNote(configure, product.type).then(res => {
          successToast("Başarılı","Notunuz başarıyla güncellendi.");
        })
      } else {
        setConfigurationNote(text);

      }

      setOpenModal(false);

    }
  };
  useEffect(() => {

    if (basket) {
      getBasketNote().then(res => {
        if (res !== null) {
          setText(res);
        }
      });
    } else {
      if (product) {
        getBasketProductNote(product.basket_id, product.id, product.product_id, product.type).then(res => {
          if (res !== null) {
            setText(res);
          }
        });
      } else {
        setText(configurationNote);
      }
    }

  }, []);
  return (
    <div className="fixed inset-0 z-10 overflow-y-auto ">
      <div className="flex items-end justify-center min-h-screen pt-4 pb-20 text-center sm:block sm:p-0 ">
        <div className="fixed inset-0 transition-opacity" aria-hidden="true">
          <div className="absolute inset-0 bg-gray-500 opacity-75" />
        </div>
        <span
          className="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
        ></span>
        <div
          className="inline-block overflow-hidden text-left align-bottom transition-all transform bg-white rounded-lg shadow-xl sm:my-8 sm:align-middle sm:max-w-2xl sm:w-full"
          role="dialog"
          aria-modal="true"
          aria-labelledby="modal-headline"
          style={{ overflow: "initial" }}
        >
          <div className="bg-white rounded-md">
            <div className="flex items-center justify-between px-5 py-5 border-b border-makdosSecondaryGray">
              <h3 className="text-2xl font-semibold">Siparişe Açıklama Ekle</h3>
              <i
                onClick={() => setOpenModal(false)}
                className="text-2xl cursor-pointer ri-close-line text-passive"
              ></i>
            </div>
            <div className="flex flex-col items-center justify-center w-full px-5 pt-4 pb-5 ">
              <div className="w-full px-">
                <SimpleTextArea value={text} onChange={(v) => setText(v)} labelName="Açıklama" textAreaName="note"
                                rows="4" placeholder="Lütfen isteklerinizi detaylı yazınız..." />
              </div>
              <div className="flex justify-end w-full mt-3">
                <Button type="button" onClick={() => onSetNote()} buttonText="Kaydet"
                        buttonRightIcon="ri-checkbox-circle-line" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
